//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState,
  mapMutations
} from "vuex";

export default {
  data() {
    return {
      selected: 'activity',
      activityIcon: require('../../assets/mobile/home-mb-select.png'),
      catIcon: require('../../assets/mobile/cata.png'),
      cartIcon: require('../../assets/mobile/cart.png'),
      myIcon: require('../../assets/mobile/user.png'),
    };
  },
  async beforeMount() {},
  mounted() {
    const menu = this.$route.path
    if (menu.indexOf('order') >= 0) {
      this.selected = 'my'
    } else if (menu.indexOf('home') >= 0) {
      this.selected = 'activity'
    } else if (menu.indexOf('cat') >= 0) {
      this.selected = 'cat'
    } else if (menu.indexOf('cart')) {
      this.selected = 'cart'
    }
  },
  components: {},
  computed: {
     ...mapState([
      'categories', 'cartList', 'campaign', 'global'
    ]),
    ...mapState(['campaign', 'global']),
    cartNum(){
      return this.cartList.cartNum>99?99:this.cartList.cartNum
    }
  },
  methods: {
    goToMenu() {
      this.$router.push({
        path: '/cat',
        query: {
          cid: this.$route.query.cid
        }
      })
    },
    goToHome() {
      this.$router.push({
        path: `/home/${this.$route.query.cid}`,
        query: {
          cid: this.$route.query.cid
        }
      })
    },
    goToCart() {
      this.$router.push({
        path: '/cartmb',
        query: {
          cid: this.$route.query.cid
        }
      })
    },
    goToMy() {
      this.$router.push({
        path: '/order',
        query: {
          cid: this.$route.query.cid
        }
      })
    }
  },
  watch: {
    selected: function (newSelected, oldSelected) {
      switch (newSelected) {
        case 'activity':
          this.activityIcon = require('../../assets/mobile/home-mb-select.png')
          break;
        case 'cat':
          if (this.global.currentActivityEnd === -13) return false
          this.catIcon = require('../../assets/mobile/cat-select.png')
          break;
        case 'cart':
          if (this.global.currentActivityEnd === -13) return false
          this.cartIcon = require('../../assets/mobile/cart-mb-select.png')
          break;
        case 'my':
          this.myIcon = require('../../assets/mobile/my-mb-select.png')
          break;
      }
      switch (oldSelected) {
        case 'activity':
          this.activityIcon = require('../../assets/mobile/home.png')
          break;
        case 'cat':
          this.catIcon = require('../../assets/mobile/cata.png')
          break;
        case 'cart':
          this.cartIcon = require('../../assets/mobile/cart.png')
          break;
        case 'my':
          this.myIcon = require('../../assets/mobile/user.png')
          break;
      }
    },
    //监听路由跳转过来，传入的值
    $route(to) {
      const menu = to.path
      if (menu.indexOf('order') >= 0) {
        this.selected = 'my'
      } else if (menu.indexOf('home') >= 0) {
        this.selected = 'activity'
      } else if (menu.indexOf('cat') >= 0) {
        this.selected = 'cat'
      } else if (menu.indexOf('cart')) {
        this.selected = 'cart'
      }
    },
  }
};




// WEBPACK FOOTER //
// ./src/components/menu/MenuMb.vue